import React from 'react';
import { useNavigate } from 'react-router-dom';

export const LightIndicator = ({ total }) => (
  <div
    className="flex items-center gap-2 px-3 py-1.5 rounded-full"
    style={{ background: 'rgba(201,168,76,0.1)' }}
    data-testid="light-indicator"
  >
    <div
      className="w-3 h-3 rounded-full"
      style={{ background: '#C9A84C', boxShadow: '0 0 8px rgba(201,168,76,0.8)' }}
    />
    <span className="text-xs tracking-[0.1em]" style={{ fontFamily: 'Jost, sans-serif', color: '#C9A84C' }}>
      {total} LIGHT
    </span>
  </div>
);

export const RestAtShoreButton = () => {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate('/inner-world/rest')}
      className="flex items-center gap-2 px-3 py-1.5 rounded-full transition-opacity hover:opacity-80 active:scale-95"
      style={{ background: 'rgba(143,169,190,0.12)' }}
      data-testid="rest-at-shore-button"
    >
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#8fa9be" strokeWidth="1.5">
        <path d="M2 12c2-2 4-2 6 0s4 2 6 0 4-2 6 0" />
        <path d="M2 17c2-2 4-2 6 0s4 2 6 0 4-2 6 0" />
      </svg>
      <span className="text-xs tracking-[0.08em]" style={{ fontFamily: 'Jost, sans-serif', color: '#8fa9be' }}>
        Rest at the Shore
      </span>
    </button>
  );
};
